import { memo, useCallback } from 'react';

import { Typography } from '@material-ui/core';

import { colors } from '../../../assets';
import { Button } from '../../button/Button';
import { BrowseFileButtonProps } from './BrowseFileButton.types';

export const BrowseFileButton = memo(
  ({ inputFileRef, acceptFormats, multiple, disabled, onChange }: BrowseFileButtonProps) => {
    const handleBrowseFiles = useCallback(() => {
      if (inputFileRef.current) {
        inputFileRef.current.click();
      }
    }, [inputFileRef]);

    return (
      <>
        <input
          style={{ display: 'none' }}
          ref={inputFileRef}
          type="file"
          accept={acceptFormats}
          multiple={multiple}
          onChange={onChange}
        />

        <div>
          <div style={{ width: 150 }}>
            <Button buttonType="outlined" fullWidth disabled={disabled.value} onClick={handleBrowseFiles}>
              Browse files
            </Button>
          </div>

          {disabled.reason && (
            <Typography variant="body2" color="textSecondary" style={{ color: colors.grey140, marginTop: 4 }}>
              {disabled.reason}
            </Typography>
          )}
        </div>
      </>
    );
  },
);
